var _style, _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipOcultar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000159455319772877518050000009919290446259862423_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    transform: "translate(17.767 15.47)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: -0.1,
    width: 12.8,
    height: 22.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013912761551624583780000001776623059968913045_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157-2",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000013912761551624583780000001776623059968913045_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    className: "st1",
    d: "M11.4,22.7c0.8,0,1.4-0.6,1.4-1.4c0-0.4-0.1-0.7-0.4-1l-9-9l9-9c0.5-0.6,0.5-1.5,0-2 c-0.5-0.5-1.4-0.5-1.9,0l-10,10c-0.6,0.5-0.6,1.4,0,2c0,0,0,0,0,0l10,10C10.6,22.5,11,22.7,11.4,22.7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipOcultar);
export default __webpack_public_path__ + "static/media/Tooltip_ocultar.0d67a3a88fe175481efc376edcfa1a9e.svg";
export { ForwardRef as ReactComponent };